import {
  DEFAULT_K8_REPORT_UNIT_SECTION,
  K8_REPORT_UNIT_SECTION,
} from 'pages/LessonCompletionReport/flag.on/constants'

const CORE_TOOLTIPS = {
  classes: 'Anyone added to this school can create a class.',
  progress: 'This shows the number of lessons marked done in each class.',
  lastLesson:
    'This shows when a teacher marked the last lesson done. Select a class to see more details.',
  markedDone:
    'This shows the last lesson marked done for each class. Teachers may teach lessons out of order. Select a class to see more details.',
}

export { CORE_TOOLTIPS }

export const UNIT_RANGE_OPTIONS = {
  CORE: 'Units 1-4',
  BHU: 'Recognizing Bullying and Harassment Unit',
}

/** Display label for Digital Well-Being curriculum (school summary table + class drawer). */
export const DIGITAL_WELL_BEING_UNIT_LABEL = 'Digital Well-Being Unit'

export const selectSchoolSummaryReportTableData = (
  state,
  selectedUnitRange = UNIT_RANGE_OPTIONS.CORE,
  k8ReportUnitSection = DEFAULT_K8_REPORT_UNIT_SECTION,
  rbhuIsEnabled = false,
  siteId = null,
) => {
  const { reportsManager } = state
  const { k8Reports, selectedSite } = reportsManager || {}
  const siteData = k8Reports?.[siteId ?? selectedSite]
  const curriculumData = siteData?.curriculum || []
  const usersById = siteData?.usersById || {}

  const effectiveUnitSection =
    k8ReportUnitSection || DEFAULT_K8_REPORT_UNIT_SECTION
  const isSpecializedTab =
    effectiveUnitSection === K8_REPORT_UNIT_SECTION.SPECIALIZED_UNITS

  let curriculumFilter
  if (isSpecializedTab) {
    curriculumFilter = 'DWB'
  } else if (selectedUnitRange === UNIT_RANGE_OPTIONS.CORE) {
    curriculumFilter = 'Core'
  } else {
    curriculumFilter = 'BHU'
  }

  const filteredClasses = curriculumData.filter(
    cls => cls.curriculum === curriculumFilter,
  )

  const allClasses = filteredClasses.map(cls => {
    const user = usersById[cls.user_id] || {}
    const lastLessonNum = cls.last_lesson_done_lesson_number
    return {
      classInstance: cls.instance,
      teacherLastName: user.last_name || '',
      teacherFirstName: user.first_name || '',
      className: cls.class_name || '',
      gradeName: cls.grade || '',
      lessonsCompleted: cls.lessons_done || 0,
      lessonsCompletedCore: cls.lessons_done || 0,
      lessonCount: cls.total_lessons || 0,
      lessonCountCore: cls.total_lessons || 0,
      hasCompletedLessonLastPeriod: cls.any_lesson_completed_in_period || false,
      lastLessonCompleted: lastLessonNum ? `lesson ${lastLessonNum}` : '',
      lastLessonCompletedParent: '',
      lastLessonCompletedTitle: cls.last_lesson_done_title || '',
      lastLessonCompletedDate: cls.last_lesson_done_on || '',
    }
  })

  const numClassesMarkedLastPeriod = allClasses.filter(
    c => c.hasCompletedLessonLastPeriod,
  ).length
  const numClassesNotMarkedLesson = allClasses.filter(
    c => c.lessonsCompleted === 0,
  ).length
  const unitRangeOptions = isSpecializedTab
    ? [DIGITAL_WELL_BEING_UNIT_LABEL]
    : rbhuIsEnabled
    ? [UNIT_RANGE_OPTIONS.CORE, UNIT_RANGE_OPTIONS.BHU]
    : [UNIT_RANGE_OPTIONS.CORE]
  return {
    activityFilterLabel: 'Recent Activity',
    classes: allClasses,
    classesTooltip: CORE_TOOLTIPS.classes,
    displayUnit5Column: false,
    lastLessonTooltip: CORE_TOOLTIPS.lastLesson,
    markedDoneTooltip: CORE_TOOLTIPS.markedDone,
    numClassesMarkedLastPeriod,
    numClassesNotMarkedLesson,
    progressTooltip: CORE_TOOLTIPS.progress,
    title: isSpecializedTab
      ? 'Specialized Unit Progress by Class'
      : 'Core Unit Progress by Class',
    totalClassesCount: allClasses.length,
    unitRangeLabel: isSpecializedTab
      ? DIGITAL_WELL_BEING_UNIT_LABEL
      : selectedUnitRange,
    unitRangeOptions,
  }
}
